import React from "react";
import { InfoCardWoOwnerDetailsProps } from "./info-card-wo-owner-details.props";
import { withShowIf } from "../../../with-show-if/with-show-If.component";
import { AvatarList } from "../../../layout/listing-table/listing-table-render-components";

export const InfoCardWoOwnerDetails = withShowIf((props: InfoCardWoOwnerDetailsProps) => (
  <>
    {`Owner: ${props.ownerName}`}
    <br />
    {`Assignees:`}
    <AvatarList users={props.contentCreatorDetails} noUsersMessage="Unassigned" />
    <br />
    {`Execution Brief: ${props.executionBriefName}`}
  </>
));
